// i18n translations - keep keys stable, add new entries at the bottom of each section
export const TRANSLATIONS = {
  fr: {
    common: {
      close: "Fermer",
      save: "Enregistrer",
      create: "Créer",
      cancel: "Annuler",
      delete: "Supprimer",
      edit: "Modifier",
      actions: "Actions",
      search: "Rechercher…",
      loading: "Chargement…",
      yes: "Oui",
      no: "Non",
      add: "Ajouter",
      filters: "Filtres",
      all: "Tous",
      none: "Aucun",
      total: "Total",
      generated_on: "Généré le",
      no_data: "Aucune donnée",
      back: "Retour",
      from: "Du",
      to: "Au",
      apply: "Appliquer",
      none_yet: "Rien à afficher pour le moment.",
      confirm_delete: "Supprimer ?",
      confirm_delete_x: (x) => `Supprimer ${x} ?`,
    },
    landing: {
      tagline: "Plateforme B2B · Distribution & E-commerce",
      h1_a: "Vos magazines.",
      h1_b: "Vos chiffres.",
      h1_c: "Un seul tableau de bord.",
      sub: "Consolidez vos ventes et vos commandes e-commerce partout dans le monde. Reporting clair, commissions automatisées, export PDF & Excel.",
      cta_start: "Commencer",
      cta_login: "Connexion",
      header_login: "Connexion",
      header_register: "S'inscrire",
      kpi_qty: "Quantité",
      kpi_qty_sub: "unités vendues",
      kpi_rev: "CA Total",
      kpi_rev_sub: "période en cours",
      kpi_commission: "Commission",
      kpi_commission_sub: "30 % retenue",
      kpi_countries: "Pays",
      kpi_countries_sub: "boutiques actives",
      feat_kpi: "KPIs en temps réel",
      feat_kpi_desc: "Quantités, chiffre d'affaires, commissions consolidés sur toutes vos sources.",
      feat_geo: "Boutiques mondiales",
      feat_geo_desc: "Suivez vos ventes par marché partout dans le monde.",
      feat_ecom: "E-commerce mensuel",
      feat_ecom_desc: "Gardez un œil sur votre CA e-commerce chaque mois — consolidé instantanément.",
      feat_export: "Export PDF & Excel",
      feat_export_desc: "Générez des rapports clairs par titre et par période en un clic.",
      footer: "© 2026 Editions Pro · Reporting des ventes",
    },
    auth: {
      session_expired: "Votre session a expiré, merci de vous reconnecter.",
      locked: (m) => `Trop de tentatives de connexion. Réessayez dans ${m} minute${m > 1 ? "s" : ""}.`,
      bad_credentials: "Email ou mot de passe incorrect.",
      login_title: "Connexion",
      login_h: "Accédez à votre espace",
      email: "Email",
      password: "Mot de passe",
      login_submit: "Se connecter",
      logging_in: "Connexion…",
      no_account: "Pas de compte ?",
      goto_register: "Créer un compte",
      welcome: "Bienvenue",
      side_h_a: "Pilotez la",
      side_h_b: "distribution",
      side_h_c: "de vos magazines.",
      side_sub: "Ventes physiques, e-commerce, commissions et exports — tout dans une interface conçue pour la précision.",
      demo_admin: "Compte démo admin",
      register_title: "Créer un compte",
      name: "Nom complet",
      role: "Rôle",
      role_client: "Client (éditeur de magazine)",
      role_admin: "Administrateur",
      client_company: "Société (client)",
      register_submit: "Créer le compte",
      creating: "Création…",
      already: "Déjà inscrit ?",
      goto_login: "Se connecter",
    },
    nav: {
      brand: "Editions Pro",
      tagline: "Reporting des ventes",
      menu: "Menu",
      dashboard: "Tableau de bord",
      reports: "Rapports",
      reports_client: "Mes rapports",
      sales: "Ventes physiques",
      sales_client: "Mes ventes physiques",
      ecommerce: "E-commerce",
      ecommerce_client: "Mes ventes en ligne",
      treasury: "Trésorerie",
      treasury_client: "Mes règlements",
      magazines: "Magazines",
      magazines_client: "Mes magazines",
      stores: "Marchés",
      clients: "Clients",
      accounts: "Comptes",
      connected: "Connecté",
      logout: "Déconnexion",
    },
    dashboard: {
      eyebrow: "Vue d'ensemble",
      title: "Tableau de bord",
      hello: (n) => `Bonjour ${n}, voici la synthèse de vos ventes.`,
      kpi_qty: "Quantité vendue",
      kpi_qty_sub: "unités · physique + e-commerce",
      kpi_rev: "Chiffre d'affaires",
      kpi_rev_sub: "toutes sources",
      kpi_commission: "Commission distribution",
      kpi_commission_sub: "retenue",
      kpi_client_rev: "Revenu client",
      kpi_client_rev_sub: "après commission",
      timeline_eyebrow: "Évolution mensuelle",
      timeline_title: "Physique vs E-commerce",
      timeline_ecom_title: "Ventes en ligne",
      timeline_ecom_eyebrow: "E-commerce — Évolution mensuelle",
      issues_eyebrow: "Performance par numéro",
      issues_title: "Évolution des ventes par numéro",
      issues_qty: "Quantité",
      issues_revenue: "Chiffre d'affaires",
      issues_no_data: "Aucune vente par numéro pour le moment.",
      legend_physical: "Physique",
      legend_ecommerce: "E-commerce",
      split_eyebrow: "Répartition",
      split_title: "CA par source",
      revenue_physical: "Ventes physiques",
      revenue_ecommerce: "Ventes en ligne",
      transactions_physical: "Transactions physiques",
      orders_ecommerce: "Saisies e-commerce",
      geo_eyebrow: "Géographie",
      geo_title: "Ventes par pays",
      geo_note: (shown, total) => `Top ${shown} sur ${total} pays.`,
      geo_see_details: "Voir le détail complet dans Mes ventes",
      perf_eyebrow: "Performances",
      perf_title: "Top magazines",
      no_sales: "Aucune vente enregistrée pour le moment.",
      units_short: "u.",
      kpi_treasury_net_due: "Net à reverser",
      kpi_treasury_net_due_sub: "ventes physiques",
      kpi_treasury_com_due: "Commission à encaisser",
      kpi_treasury_com_due_sub: "ventes e-commerce",
      treasury_settled: "Soldé",
      year_all: "Toutes les années",
      kpi_qty_client: "Mes ventes",
      kpi_client_rev_client: "Mon revenu net",
      kpi_treasury_net_due_client: "Reste à recevoir",
      kpi_secondary_sub: (c) => `dont ${c} de commission`,
      summary_client: (p, qty, countries, net) => `Sur ${p}, ${qty} exemplaires vendus dans ${countries} pays, ${net} nets pour vous.`.replace("Sur l'ensemble", "Sur l'ensemble"),
      customize: "Personnaliser",
      customize_hint: "Glissez pour réordonner, décochez pour masquer. Vos réglages sont mémorisés.",
      customize_reset: "Réinitialiser l'affichage",
      customize_reset_done: "Affichage réinitialisé",
      all_hidden: "Toutes les rubriques sont masquées. Ouvrez « Personnaliser » pour en réafficher.",
      period_all: "l'ensemble de la période",
      export_pdf: (p) => `Mon rapport ${p} (PDF)`,
      export_pdf_all: "Mon rapport complet (PDF)",
      export_done: "Rapport PDF téléchargé",
      empty_title: "Aucune vente sur cette période",
      empty_sub: (p) => `Rien n'a encore été enregistré pour ${p}. Changez de période ou revenez après la prochaine remontée des ventes.`,
    },
    checklist: {
      title: "Préparation du test client",
      pending: (n, total) => `${n} étape${n > 1 ? "s" : ""} restante${n > 1 ? "s" : ""} sur ${total}`,
      all_done: "Tout est prêt : vous pouvez lancer le test client.",
      add: "Ajouter",
      add_placeholder: "Ajouter une étape…",
    },
    integrity: {
      title: "Contrôle de cohérence",
      sub: (n) => `${n} ligne(s) ne correspondent plus aux taux de la fiche client.`,
      mismatch: (ar, er, av, ev) => `commission ${ar ?? "—"} % au lieu de ${er ?? "—"} % · TVA ${av ?? "—"} % au lieu de ${ev ?? "—"} %`,
      orphan: "aucun client rattaché à ce magazine",
      and_more: (n) => `… et ${n} autre(s) ligne(s).`,
      recompute: "Recalculer tout",
      recomputed: (s, e) => `Recalcul terminé : ${s} vente(s) et ${e} entrée(s) e-commerce mises à jour.`,
    },
    treasury: {
      eyebrow: "Trésorerie",
      title: "Suivi des règlements",
      subtitle: "Reversements aux clients (physique) et facturation de la commission (e-commerce).",
      subtitle_client: "Suivez les reversements à recevoir (physique) et les commissions à régler (e-commerce).",
      kpi_net_due: "Reste à reverser",
      kpi_net_due_client: "Reste à recevoir",
      kpi_com_to_invoice: "Reste à encaisser",
      kpi_net_balance: "Solde net",
      kpi_due_split: (phys, ca) => `Dont ventes physiques ${phys} · CA e-commerce ${ca}`,
      kpi_net_balance_client: "Votre solde net",
      net_in_favor_client: "en faveur du client (à reverser)",
      net_in_favor_client_client: "en votre faveur (à recevoir)",
      net_in_favor_kd: "en faveur de KD Presse (à encaisser)",
      net_in_favor_kd_client: "à régler à KD Presse",
      net_settled: "Tout est soldé",
      kpi_com_to_invoice_client: "Reste à régler",
      over: "sur",
      paid: "réglés",
      received: "reçus",
      invoiced: "facturés",
      paid_lower: "réglés",
      payouts_eyebrow: "Ventes physiques · par numéro",
      payouts_title: "Reversements aux clients",
      payouts_title_client: "Reversements à recevoir",
      payouts_subtitle: "Vous encaissez le CA physique, déduisez la commission et reversez le net au client.",
      payouts_subtitle_client: "Joignez votre facture par numéro pour recevoir votre reversement.",
      invoices_eyebrow: "Ventes e-commerce · par période",
      invoices_title: "Facturation de la commission",
      invoices_title_client: "Commissions à régler",
      invoices_subtitle: "Vous encaissez les ventes en ligne : reversez le CA TTC à l'éditeur et facturez-lui votre commission.",
      invoices_subtitle_client: "KD Presse encaisse vos ventes en ligne, vous reverse le CA TTC et vous facture sa commission.",
      clients_eyebrow: "Vue par client",
      clients_title: "Clients",
      clients_subtitle: "Cliquez sur un client pour dérouler ses reversements et ses factures de commission.",
      col_lines: "Lignes",
      col_ecom_to_pay: "Reste à régler (e-com + prestations)",
      back_to_clients: "Retour aux clients",
      col_client: "Client",
      col_magazine: "Magazine",
      col_period: "Période",
      col_revenue: "CA",
      col_commission: "Commission",
      col_commission_due: "Commission due",
      col_net_due: "Net à verser",
      col_net_due_client: "Net à recevoir",
      col_paid: "Versé",
      col_paid_client: "Reçu",
      col_invoiced: "Facturé",
      col_invoiced_client: "Dû",
      col_remaining: "Solde",
      col_status: "Statut",
      col_actions: "",
      status_settled: "Soldé",
      status_partial: "Partiel",
      status_pending: "En attente",
      status_paid: "Payée",
      status_invoiced: "Facturée",
      btn_mark_paid: "Saisir un versement",
      btn_mark_invoiced: "Saisir une facture",
      btn_attach_invoice: "Joindre une facture",
      attachments: "Factures jointes",
      download: "Télécharger",
      mark_paid: "Marquer payée",
      unmark_paid: "Annuler le paiement",
      col_ca_paid: "CA reversé",
      btn_ca: "Reverser le CA",
      ca_title: "Reverser le CA e-commerce à l'éditeur",
      ca_text: (client, period, due, left) => `${client} · ${period} : CA TTC ${due}, reste à reverser ${left}.`,
      ca_amount: "Montant reversé (€)",
      ca_reference: "Référence (n° de virement, facultatif)",
      ca_ok: "Reversement du CA enregistré",
      ca_paid_on: (d) => `CA reversé le ${d}`,
      ca_done: "Reversé",
      ca_left: (amt) => `reste ${amt}`,
      ca_delete_confirm: "Supprimer ce reversement de CA ?",
      status_unallocated: "À ventiler",
      to_allocate: "À ventiler (enregistré sans marché)",
      allocate_title: "Rattacher à un marché",
      allocate_payout: (d, amt) => `Reversement du ${d} · ${amt}`,
      allocate_invoice: (ref, amt) => `Facture ${ref} · ${amt}`,
      allocate_choose: "Choisir le marché…",
      allocated_ok: "Rattaché au marché",
      filter_due: "À régler",
      filter_paid: "Payées",
      filter_all: "Toutes",
      help_title: "Comment ça marche ?",
      help_physical: "Ventes en boutique · Reversements à recevoir",
      help_p1_title: "KD Presse calcule votre net",
      help_p1: "Nous encaissons vos ventes en boutique et calculons, pour chaque numéro et chaque marché, le montant qui vous revient (colonne « Net à recevoir »).",
      help_p2_title: "Vous joignez votre facture",
      help_p2: "Établissez une facture du montant « Net à recevoir », puis déposez-la en PDF avec le bouton « Joindre une facture » sur la ligne concernée.",
      help_p3_title: "Nous vous payons",
      help_p3: "Dès que le virement est effectué, la ligne passe en « Soldé » et le montant apparaît dans la colonne « Reçu ».",
      help_ecom: "Ventes en ligne · Commissions à régler",
      help_e1_title: "Téléchargez la facture de commission",
      help_e1: "Chaque période, KD Presse vous reverse le CA de vos ventes en ligne et dépose sa facture de commission sous la ligne. Cliquez sur « Télécharger ».",
      help_e2_title: "Réglez le solde",
      help_e2: "Réglez le montant affiché dans la colonne « Solde ». Une fois le paiement reçu, la période passe en « Payée ».",
      todo_title: "À faire :",
      todo_attach: (n) => `${n} facture${n > 1 ? "s" : ""} à joindre`,
      todo_pay: (n, amt) => `${n} commission${n > 1 ? "s" : ""} à régler (${amt})`,
      invoice_received: "Facture reçue",
      col_vat: "TVA",
      kpi_split: (ecom, svc) => `dont e-commerce ${ecom} · prestations ${svc}`,
      col_copies: "Ex. vendus",
      todo_services: (n, amt) => `${n} facture${n > 1 ? "s" : ""} de prestation à régler (${amt})`,
      col_market: "Marché",
      attach_hint: "Établissez votre facture du montant net indiqué ci-dessus, puis déposez le PDF. Le montant est pré-rempli, vous pouvez le modifier.",
      tip_market: "Vos ventes sont séparées par marché : Direct to retail (boutiques en direct), Wholesale France (distribution en France) et Worldwide Wholesale (distribution à l'étranger). Une facture par ligne.",
      tip_net_due: "CA TTC de vos ventes en boutique, moins la commission KD Presse. C'est le montant de votre facture.",
      tip_remaining: "Ce qu'il reste à payer sur la ligne. En rouge tant qu'il n'est pas à zéro.",
      tip_status: "En attente : rien n'est encore payé. Partiel : une partie est payée. Soldé / Payée : tout est réglé.",
      tip_remaining_ecom: "Montant de la commission (et du stockage éventuel) qu'il vous reste à régler à KD Presse pour cette période.",
      faq_title: "Questions fréquentes",
      faq_q1: "Pourquoi mon solde est-il en rouge ?",
      faq_a1: "Un solde en rouge signifie qu'un montant reste à payer sur la ligne : un reversement que KD Presse doit encore vous faire, ou une commission que vous devez encore régler. Il repasse en noir une fois la ligne réglée.",
      faq_q2: "J'ai joint la mauvaise facture, que faire ?",
      faq_a2: "Sous la ligne, dans « Factures jointes », supprimez le fichier concerné puis cliquez à nouveau sur « Joindre une facture » pour déposer le bon PDF.",
      faq_q3: "Pourquoi un même numéro apparaît sur plusieurs lignes ?",
      faq_a3: "Un numéro peut être vendu sur plusieurs marchés (Direct to retail, Wholesale France, Worldwide Wholesale). Chaque marché a sa propre ligne : joignez une facture pour chacune.",
      faq_q4: "Comment savoir si j'ai été payé ?",
      faq_a4: "La colonne « Reçu » indique le montant versé et la ligne passe en « Soldé ». Le détail des virements (date, montant, référence) s'affiche sous la ligne. Utilisez le filtre « Payées » pour ne voir que les lignes réglées.",
      btn_settle: "Marquer payée",
      settle_title: "Marquer la période payée sans facture",
      settle_text: (client, period, amt) => `${client} · ${period} : le reste à payer (${amt}) sera enregistré comme réglé, sans facture PDF. Les factures déjà saisies pour cette période passent aussi en payées.`,
      settle_date: "Date du règlement",
      settled_ok: "Période marquée payée",
      settled_no_invoice: "Réglé sans facture",
      marked_paid: "Facture marquée comme payée.",
      marked_unpaid: "Statut payée annulé.",
      paid_on: "Payée le",
      invoice_attached: "Facture jointe.",
      error_pdf_required: "Veuillez sélectionner un fichier PDF.",
      error_pdf_only: "Seuls les fichiers PDF sont acceptés.",
      no_payouts: "Aucune vente physique éligible.",
      no_invoices: "Aucune saisie e-commerce éligible.",
      history: "Historique",
      ref: "Réf.",
      remove: "Supprimer",
      confirm_delete: "Supprimer cette entrée ?",
      deleted: "Entrée supprimée.",
      payout_saved: "Versement enregistré.",
      invoice_saved: "Facture enregistrée.",
      error_amount: "Montant invalide.",
      error_date: "Date invalide.",
      dlg_payout_title: "Enregistrer un versement",
      dlg_invoice_title: "Enregistrer une facture",
      dlg_invoice_edit_title: "Modifier la facture",
      help_pdf_keep: (n) => `Laissez vide pour conserver le PDF actuel (${n}).`,
      invoice_updated: "Facture modifiée",
      dlg_attach_invoice_title: "Joindre une facture",
      field_amount: "Montant (€)",
      field_amount_optional: "Montant (€) — optionnel",
      field_paid_at: "Date du versement",
      field_invoiced_at: "Date de facturation",
      field_reference: "Référence (virement, chèque…)",
      field_invoice_no: "N° de facture",
      field_notes: "Notes",
      field_pdf_invoice: "Fichier PDF de la facture",
      help_pdf_required: "Le fichier doit être au format PDF (10 Mo max).",
      placeholder_reference: "ex. VIR-2026-001",
      placeholder_invoice_no: "ex. F2026-042",
    },
    reports: {
      eyebrow: "Reporting",
      title: "Rapports détaillés",
      filter_client: "Client",
      filter_magazine: "Magazine",
      filter_store: "Boutique",
      run: "Générer le rapport",
      computing: "Calcul…",
      excel: "Excel",
      pdf: "PDF",
      all_clients: "Tous les clients",
      all_magazines: "Tous",
      n_magazines: (n) => `${n} numéros sélectionnés`,
      all_stores: "Toutes",
      kpi_qty: "Qté",
      kpi_rev: "CA TTC",
      kpi_rev_ht: "CA HT",
      kpi_vat: "TVA",
      kpi_commission: "Commission",
      kpi_client_rev: "Revenu client",
      kpi_phys: "CA Physique",
      kpi_ecom: "CA E-com.",
      table_by_mag: "Par magazine",
      table_by_store: "Par boutique",
      th_magazine: "Magazine",
      th_issue: "Numéro",
      th_qty: "Qté",
      th_revenue: "CA",
      th_commission: "Commission",
      th_store: "Boutique",
      th_city: "Ville",
      th_country: "Pays",
      no_data: "Aucune donnée",
      excel_downloaded: "Export Excel téléchargé",
      pdf_downloaded: "Export PDF téléchargé",
    },
    clients: {
      eyebrow: "Gestion",
      title: "Clients",
      sub: "Éditeurs de magazines distribués par votre plateforme. Liez un compte pour leur donner accès à leur reporting.",
      new: "Nouveau client",
      edit_title: "Modifier le client",
      new_title: "Nouveau client",
      f_name: "Nom",
      f_contact: "Email contact",
      f_country: "Pays",
      f_rate_phys: "Commission physique (%)",
      f_rate_ecom: "Commission e-com (%)",
      f_vat: "TVA (%)",
      rate_ecom_hint: "Laissez la commission e-com vide pour utiliser le même taux que le physique.",
      sel_country: "Sélectionner un pays",
      country_hint: "Choisissez « France » pour appliquer la TVA sur les ventes physiques. Tout autre pays : le P.U. est converti en HT (÷ 1,2) et aucune TVA n'est collectée.",
      th_name: "Nom",
      th_contact: "Contact",
      th_country: "Pays",
      th_rate_phys: "Comm. physique",
      th_rate_ecom: "Comm. e-com",
      th_vat: "TVA",
      th_actions: "Actions",
      same_as_phys: (x) => `idem (${x} %)`,
      none_yet: "Aucun client. Créez-en un pour commencer.",
      created: "Client créé",
      updated: "Client modifié — commissions recalculées sur les ventes existantes",
      deleted: "Supprimé",
      confirm_del: "Supprimer ce client ?",
      accounts_title: (n) => `Comptes liés — ${n}`,
      accounts_existing: "Comptes existants",
      accounts_none: "Aucun compte lié à ce client. Créez-en un ci-dessous.",
      accounts_new: "Créer un nouveau compte",
      access_hint: (n) => `Ce compte aura accès en lecture seule au reporting des magazines de ${n}.`,
      create_account: "Créer le compte",
      new_password: "Nouveau mot de passe (min. 6 caractères) :",
      pw_reset: "Mot de passe réinitialisé",
      account_deleted: "Compte supprimé",
      account_created: (e) => `Compte créé pour ${e}`,
      btn_accounts: "Comptes",
      btn_password: "Mot de passe",
    },
    magazines: {
      eyebrow: "Catalogue",
      title: "Magazines",
      new: "Nouveau numéro",
      edit_title: "Modifier le numéro",
      new_title: "Nouveau numéro",
      f_client: "Client",
      f_title: "Titre",
      f_issue: "Numéro / édition",
      f_price: "Prix unitaire",
      f_currency: "Devise",
      f_cover: "Couverture (image)",
      f_cover_hint: "JPG, PNG ou WEBP · 5 Mo max. L'image est stockée sur le serveur.",
      cover_current: "Couverture actuelle",
      cover_uploaded: "Couverture mise à jour",
      sel_client: "Sélectionner",
      created: "Magazine créé",
      updated: "Magazine modifié",
      none_yet: "Aucun magazine.",
      search: "Rechercher un titre ou un numéro…",
      no_results: "Aucun magazine ne correspond à la recherche.",
      no_client: "Sans client",
      issues_count: (n) => `${n} numéro${n > 1 ? "s" : ""}`,
      titles_count: (n) => `${n} titre${n > 1 ? "s" : ""}`,
      last_issue: "Dernier :",
      f_rate: "Commission ventes physiques (%)",
      f_rate_ph: (r) => `Taux du client : ${r} %`,
      f_rate_hint: "Laissez vide pour appliquer le taux du client. Un taux saisi ici s'applique aux ventes enregistrées après la modification.",
    },
    stores: {
      eyebrow: "Réseau",
      title: "Points de vente",
      sub: "Boutiques dans le monde entier qui distribuent vos magazines.",
      new: "Nouvelle boutique",
      edit_title: "Modifier la boutique",
      new_title: "Nouvelle boutique",
      f_name: "Nom",
      f_city: "Ville",
      f_country: "Pays",
      f_address: "Adresse",
      created: "Boutique créée",
      updated: "Boutique modifiée",
      none_yet: "Aucune boutique.",
    },
    sales: {
      eyebrow: "Distribution physique",
      title: "Ventes physiques",
      sub: "Enregistrez les ventes remontées par chaque marché.",
      new: "Saisir une vente",
      edit_title: "Modifier la vente",
      new_title: "Nouvelle vente",
      f_magazine: "Magazine",
      f_store: "Boutique",
      f_qty: "Quantité",
      f_price: "Prix unitaire (option.)",
      f_price_auto: "auto",
      f_price_hint: "Prix public TTC. Pour un client hors France, le P.U. est automatiquement converti en HT (÷ 1,2).",
      f_rate: "Taux de commission (%)",
      f_rate_ph: (r) => `Taux du client : ${r} %`,
      f_rate_hint: "Laissez vide pour appliquer le taux du client. Renseignez un taux pour une boutique à conditions particulières (ex. 50 %).",
      rate_specific: "taux spécifique",
      f_date: "Date",
      f_period: "Période",
      th_date: "Date",
      th_magazine: "Magazine",
      th_store: "Boutique",
      th_qty: "Qté",
      th_pu: "P.U.",
      th_revenue: "CA",
      th_commission: "Commission",
      created: "Vente enregistrée",
      updated: "Vente modifiée",
      none_yet: "Aucune vente enregistrée pour ce numéro.",
      no_magazines: "Aucun magazine. Créez d'abord un magazine puis enregistrez des ventes.",
      no_issues: "Aucun numéro pour ce magazine.",
      bc_all_magazines: "Tous les magazines",
      back_to_titles: "Retour aux magazines",
      back_to_issues: "Retour aux numéros",
      col_issues: "Numéros",
      col_issue: "Numéro",
      col_sales: "Ventes",
      kpi_titles: "Magazines",
      kpi_issues: "Numéros",
      kpi_sales: "Ventes",
      kpi_qty: "Quantité",
      kpi_revenue: "Chiffre d'affaires",
      btn_add_sale: "Ajouter une vente",
      card_net: "Net client",
      card_by_country: "Répartition par pays",
      card_other_countries: "autres pays",
      card_see_sales: "Voir les ventes",
      units_short: "ex.",
    },
    ecom: {
      eyebrow: "E-commerce",
      title: "Ventes en ligne",
      sub: "Saisissez le chiffre d'affaires e-commerce par période et par client. Vous pouvez aussi ajouter des frais de stockage refacturables au client.",
      new: "Nouvelle saisie",
      edit_title: "Modifier l'entrée e-commerce",
      new_title: "Nouvelle saisie e-commerce",
      f_client: "Client",
      f_period_start: "Début de période",
      f_period_end: "Fin de période",
      f_revenue: "Chiffre d'affaires TTC",
      f_currency: "Devise",
      f_qty: "Quantité (optionnel)",
      f_storage_ht: "Frais de stockage HT",
      f_storage_hint: "TVA de 20 % (0 % si le client n'a pas de TVA). Total ajouté à la commission à refacturer.",
      f_notes: "Notes (optionnel)",
      f_notes_ph: "ex. promotion d'été…",
      err_client: "Sélectionnez un client.",
      err_period: "Sélectionnez les dates de début et fin de période.",
      err_period_order: "La date de fin doit être postérieure à la date de début.",
      err_revenue: "Montant invalide.",
      save: "Enregistrer la saisie",
      kpi_entries: "Entrées",
      kpi_revenue: "CA E-commerce",
      kpi_commission: "Commission cumulée (HT)",
      kpi_storage: "Stockage cumulé (TTC)",
      kpi_to_invoice: "À refacturer (TTC)",
      history: "Historique des saisies",
      one_per: "Une ligne par période × client",
      sub_client: "Vos ventes en ligne mois par mois, avec la commission et les frais de stockage facturés par KD Presse.",
      history_client: "Détail par mois",
      one_per_client: "Vos ventes en ligne, mois par mois",
      th_your_rev: "Votre revenu net",
      all_clients: "Tous les clients",
      th_period: "Période",
      th_month: "Mois",
      th_client: "Client",
      th_qty: "Quantité",
      th_revenue: "CA",
      th_commission: "Commission (HT)",
      th_storage: "Stockage (TTC)",
      th_invoiced: "À refacturer (TTC)",
      th_client_rev: "Revenu client",
      th_notes: "Notes",
      created: "Entrée enregistrée",
      updated: "Entrée modifiée",
      deleted: "Supprimée",
      none_yet: "Aucune saisie e-commerce. Cliquez sur « Nouvelle saisie » pour enregistrer une période.",
      detail: "Détail des commandes (Excel)",
      detail_downloaded: "Détail des commandes téléchargé",
      f_rate: "Commission e-commerce (%)",
      f_rate_ph: (r) => `Taux du client : ${r} %`,
      f_rate_hint: "Laissez vide pour appliquer le taux du client. Renseignez un taux pour appliquer une commission différente sur cette période.",
    },
    shopify: {
      title: "Boutique Shopify",
      f_collections: "Collections Shopify",
      linked: (n) => `Shopify · ${n} collection${n > 1 ? "s" : ""}`,
      search_ph: "Rechercher une collection…",
      loading: "Chargement des collections…",
      no_match: "Aucune collection ne correspond.",
      n_products: (n) => `${n} produit${n > 1 ? "s" : ""}`,
      unlink: "Délier la collection",
      picker_hint: "Toutes les ventes en ligne des produits de ces collections sont attribuées à ce client. Une collection ne peut appartenir qu'à un seul client.",
      test: "Tester la connexion",
      test_ok: (name, n) => `Connecté à ${name} · ${n} commandes`,
      sync_now: "Synchroniser maintenant",
      sync_started: "Synchronisation lancée",
      sync_done: "Synchronisation Shopify terminée",
      running: (n) => `Synchronisation en cours… ${n} commandes lues`,
      last_sync: (d, n) => `Dernière synchronisation : ${d} · ${n} commandes · mise à jour automatique chaque nuit`,
      never: "Jamais synchronisée — cliquez sur « Synchroniser maintenant » pour importer tout l'historique.",
      unattributed: (amt) => `Ventes non attribuées : ${amt} (produits hors des collections reliées)`,
      skipped: (n) => `${n} mois ignoré(s) : déjà couverts par une saisie manuelle`,
      replaceable: (n) => `${n} saisie(s) manuelle(s) remplaçable(s) par Shopify`,
      manual: "Saisi",
      n_invoices: (n) => `${n} facture(s) attachée(s)`,
      replace_btn: "Remplacer par Shopify",
      replace_title: "Remplacer la saisie manuelle par Shopify",
      replace_text: (client, period, manual, shop, n) => `${client} · ${period} : la saisie manuelle (${manual}) sera supprimée et remplacée par ${n} mois Shopify (${shop} au total).`,
      replace_storage: (amt) => `Les frais de stockage (${amt} HT) seront reportés sur le dernier mois de la période.`,
      replace_invoices: (n, amt) => `Attention : ${n} facture(s) de commission (${amt}) rattachée(s) à cette période seront supprimées définitivement, PDF compris.`,
      replaced_ok: "Saisie remplacée par les mois Shopify",
      replace_payouts: (n) => `Attention : ${n} reversement(s) de CA enregistré(s) sur cette période seront supprimés.`,
      locked_hint: "Entrée synchronisée depuis Shopify : CA, quantité et période sont mis à jour automatiquement. Seuls les frais de stockage et la note sont modifiables.",
    },
    services: {
      title: "Autres factures · Prestations",
      subtitle: "Factures de distribution, livraison, marketing… adressées aux éditeurs, avec suivi de paiement.",
      subtitle_client: "Factures de prestations de KD Presse (distribution, livraison, marketing…) à régler.",
      btn_add: "Ajouter une facture",
      dlg_title: "Nouvelle facture de prestation",
      col_date: "Date",
      col_category: "Catégorie",
      col_description: "Description",
      col_amount: "Montant TTC",
      field_pdf: "Facture (PDF)",
      placeholder_description: "Ex. Distribution Japon – mai 2026",
      cat_distribution: "Distribution",
      cat_delivery: "Livraison",
      cat_marketing: "Marketing",
      cat_other: "Autre",
      error_required: "Client, date, montant et PDF sont obligatoires.",
      created: "Facture ajoutée",
      updated: "Facture modifiée",
      dlg_edit_title: "Modifier la facture de prestation",
      btn_mark_paid: "Marquer payée",
      btn_unmark: "Annuler le paiement",
      marked_paid: "Facture marquée payée",
      confirm_delete: "Supprimer cette facture ?",
      deleted: "Facture supprimée",
      empty: "Aucune facture de prestation.",
    },
    accounts: {
      locked_until: (h) => `Bloqué jusqu'à ${h}`,
      btn_unlock: "Débloquer",
      unlocked: (e) => `Compte débloqué : ${e}`,
      eyebrow: "Administration",
      title: "Comptes utilisateurs",
      sub: "Tous les comptes ayant accès à la plateforme — administrateurs et clients.",
      new: "Nouveau compte",
      edit_title: "Modifier le compte",
      new_title: "Nouveau compte",
      stat_total: "Total",
      stat_admins: "Administrateurs",
      stat_clients: "Clients",
      stat_unlinked: "Non liés",
      f_email: "Email",
      f_email_locked: "L'email ne peut pas être modifié.",
      f_name: "Nom",
      f_pw: "Mot de passe",
      f_pw_keep: "Mot de passe (laisser vide pour conserver)",
      f_pw_ph: "min 6 car.",
      f_role: "Rôle",
      f_client: "Client lié",
      f_client_ph: "Choisir",
      role_client: "Client",
      role_admin: "Administrateur",
      filter_role: "Tous les rôles",
      filter_admins: "Administrateurs",
      filter_clients: "Clients",
      filter_all_clients: "Tous les clients",
      filter_unlinked: "Non liés",
      th_account: "Compte",
      th_email: "Email",
      th_role: "Rôle",
      th_client: "Client lié",
      th_created: "Créé le",
      you: "(vous)",
      unlinked: "Non lié",
      none_match: "Aucun compte ne correspond aux filtres.",
      created: "Compte créé",
      updated: "Compte modifié",
      deleted: "Compte supprimé",
      cant_delete_self: "Vous ne pouvez pas supprimer votre propre compte",
      create_btn: "Créer le compte",
      save_btn: "Enregistrer",
      pw_required: "Mot de passe d'au moins 6 caractères requis",
      pw_too_short: "Mot de passe trop court",
      client_required: "Sélectionnez un client pour ce compte",
      pw_prompt: (e) => `Nouveau mot de passe pour ${e} (min. 6 caractères) :`,
      pw_reset: "Mot de passe réinitialisé",
      btn_reset_pw: "Mot de passe",
      confirm_del: (e) => `Supprimer définitivement le compte ${e} ?`,
    },
  },
  en: {
    common: {
      close: "Close",
      save: "Save",
      create: "Create",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      actions: "Actions",
      search: "Search…",
      loading: "Loading…",
      yes: "Yes",
      no: "No",
      add: "Add",
      filters: "Filters",
      all: "All",
      none: "None",
      total: "Total",
      generated_on: "Generated on",
      no_data: "No data",
      back: "Back",
      from: "From",
      to: "To",
      apply: "Apply",
      none_yet: "Nothing to show yet.",
      confirm_delete: "Delete?",
      confirm_delete_x: (x) => `Delete ${x}?`,
    },
    landing: {
      tagline: "B2B Platform · Distribution & E-commerce",
      h1_a: "Your magazines.",
      h1_b: "Your numbers.",
      h1_c: "One single dashboard.",
      sub: "Consolidate your sales and e-commerce orders worldwide. Clear reporting, automated commissions, PDF & Excel export.",
      cta_start: "Get started",
      cta_login: "Sign in",
      header_login: "Sign in",
      header_register: "Sign up",
      kpi_qty: "Quantity",
      kpi_qty_sub: "units sold",
      kpi_rev: "Total Revenue",
      kpi_rev_sub: "current period",
      kpi_commission: "Commission",
      kpi_commission_sub: "30% retained",
      kpi_countries: "Countries",
      kpi_countries_sub: "active stores",
      feat_kpi: "Real-time KPIs",
      feat_kpi_desc: "Quantities, revenue, commissions consolidated across all sources.",
      feat_geo: "Global stores",
      feat_geo_desc: "Track your sales by market across the world.",
      feat_ecom: "Monthly e-commerce",
      feat_ecom_desc: "Keep an eye on your monthly e-commerce revenue — consolidated instantly.",
      feat_export: "PDF & Excel export",
      feat_export_desc: "Generate clear reports by title and period in one click.",
      footer: "© 2026 Editions Pro · Sales Reporting",
    },
    auth: {
      session_expired: "Your session has expired, please log in again.",
      locked: (m) => `Too many login attempts. Try again in ${m} minute${m > 1 ? "s" : ""}.`,
      bad_credentials: "Incorrect email or password.",
      login_title: "Sign in",
      login_h: "Access your workspace",
      email: "Email",
      password: "Password",
      login_submit: "Sign in",
      logging_in: "Signing in…",
      no_account: "No account?",
      goto_register: "Create an account",
      welcome: "Welcome",
      side_h_a: "Run your",
      side_h_b: "magazines'",
      side_h_c: "distribution.",
      side_sub: "Physical sales, e-commerce, commissions and exports — all in one interface designed for precision.",
      demo_admin: "Demo admin account",
      register_title: "Create an account",
      name: "Full name",
      role: "Role",
      role_client: "Client (magazine publisher)",
      role_admin: "Administrator",
      client_company: "Company (client)",
      register_submit: "Create account",
      creating: "Creating…",
      already: "Already registered?",
      goto_login: "Sign in",
    },
    nav: {
      brand: "Editions Pro",
      tagline: "Sales Reporting",
      menu: "Menu",
      dashboard: "Dashboard",
      reports: "Reports",
      reports_client: "My reports",
      sales: "Physical sales",
      sales_client: "My physical sales",
      ecommerce: "E-commerce",
      ecommerce_client: "My online sales",
      treasury: "Treasury",
      treasury_client: "My settlements",
      magazines: "Magazines",
      magazines_client: "My magazines",
      stores: "Markets",
      clients: "Clients",
      accounts: "Accounts",
      connected: "Signed in",
      logout: "Sign out",
    },
    dashboard: {
      eyebrow: "Overview",
      title: "Dashboard",
      hello: (n) => `Hello ${n}, here's your sales summary.`,
      kpi_qty: "Units sold",
      kpi_qty_sub: "physical + e-commerce",
      kpi_rev: "Revenue",
      kpi_rev_sub: "all sources",
      kpi_commission: "Distribution commission",
      kpi_commission_sub: "retained",
      kpi_client_rev: "Client revenue",
      kpi_client_rev_sub: "after commission",
      timeline_eyebrow: "Monthly trend",
      timeline_title: "Physical vs E-commerce",
      timeline_ecom_title: "Online sales",
      timeline_ecom_eyebrow: "E-commerce — Monthly trend",
      issues_eyebrow: "Performance by issue",
      issues_title: "Sales evolution by issue",
      issues_qty: "Quantity",
      issues_revenue: "Revenue",
      issues_no_data: "No sales by issue yet.",
      legend_physical: "Physical",
      legend_ecommerce: "E-commerce",
      split_eyebrow: "Breakdown",
      split_title: "Revenue by source",
      revenue_physical: "Physical sales",
      revenue_ecommerce: "Online sales",
      transactions_physical: "Physical transactions",
      orders_ecommerce: "E-commerce entries",
      geo_eyebrow: "Geography",
      geo_title: "Sales by country",
      geo_note: (shown, total) => `Top ${shown} of ${total} countries.`,
      geo_see_details: "See the full breakdown in My sales",
      perf_eyebrow: "Performance",
      perf_title: "Top magazines",
      no_sales: "No sales recorded yet.",
      units_short: "u.",
      kpi_treasury_net_due: "Net to pay out",
      kpi_treasury_net_due_sub: "physical sales",
      kpi_treasury_com_due: "Commission to collect",
      kpi_treasury_com_due_sub: "e-commerce sales",
      treasury_settled: "Settled",
      year_all: "All years",
      kpi_qty_client: "My sales",
      kpi_client_rev_client: "My net revenue",
      kpi_treasury_net_due_client: "Remaining to receive",
      kpi_secondary_sub: (c) => `incl. ${c} commission`,
      summary_client: (p, qty, countries, net) => `In ${p}, ${qty} copies sold across ${countries} countries, ${net} net for you.`,
      customize: "Customize",
      customize_hint: "Drag to reorder, switch off to hide. Your settings are saved.",
      customize_reset: "Reset layout",
      customize_reset_done: "Layout reset",
      all_hidden: "All sections are hidden. Open “Customize” to bring them back.",
      period_all: "the full period",
      export_pdf: (p) => `My ${p} report (PDF)`,
      export_pdf_all: "My full report (PDF)",
      export_done: "PDF report downloaded",
      empty_title: "No sales for this period",
      empty_sub: (p) => `Nothing recorded yet for ${p}. Change the period or come back after the next sales upload.`,
    },
    checklist: {
      title: "Client test preparation",
      pending: (n, total) => `${n} step${n > 1 ? "s" : ""} left out of ${total}`,
      all_done: "All set: you can start the client test.",
      add: "Add",
      add_placeholder: "Add a step…",
    },
    integrity: {
      title: "Consistency check",
      sub: (n) => `${n} row(s) no longer match the client's rates.`,
      mismatch: (ar, er, av, ev) => `commission ${ar ?? "—"}% instead of ${er ?? "—"}% · VAT ${av ?? "—"}% instead of ${ev ?? "—"}%`,
      orphan: "no client linked to this magazine",
      and_more: (n) => `… and ${n} more row(s).`,
      recompute: "Recompute all",
      recomputed: (s, e) => `Done: ${s} sale(s) and ${e} e-commerce entry(ies) updated.`,
    },
    treasury: {
      eyebrow: "Treasury",
      title: "Settlement tracking",
      subtitle: "Payouts to clients (physical) and commission invoicing (e-commerce).",
      subtitle_client: "Track the payouts you should receive (physical) and the commissions you need to pay (e-commerce).",
      kpi_net_due: "Remaining to pay out",
      kpi_net_due_client: "Remaining to receive",
      kpi_com_to_invoice: "Remaining to collect",
      kpi_net_balance: "Net balance",
      kpi_due_split: (phys, ca) => `Incl. physical sales ${phys} · e-commerce revenue ${ca}`,
      kpi_net_balance_client: "Your net balance",
      net_in_favor_client: "in the client's favour (to pay out)",
      net_in_favor_client_client: "in your favour (to receive)",
      net_in_favor_kd: "in KD Presse's favour (to collect)",
      net_in_favor_kd_client: "to pay KD Presse",
      net_settled: "Everything is settled",
      kpi_com_to_invoice_client: "Remaining to pay",
      over: "of",
      paid: "paid",
      received: "received",
      invoiced: "invoiced",
      paid_lower: "paid",
      payouts_eyebrow: "Physical sales · by issue",
      payouts_title: "Payouts to clients",
      payouts_title_client: "Payouts to receive",
      payouts_subtitle: "You collect physical revenue, deduct your commission and pay the net to the client.",
      payouts_subtitle_client: "Attach your invoice per issue to receive your payout.",
      invoices_eyebrow: "E-commerce sales · by period",
      invoices_title: "Commission invoicing",
      invoices_title_client: "Commissions to pay",
      invoices_subtitle: "You collect online sales: pay the revenue incl. VAT to the publisher and invoice your commission.",
      invoices_subtitle_client: "KD Presse collects your online sales, pays you the revenue incl. VAT and invoices its commission.",
      clients_eyebrow: "By client",
      clients_title: "Clients",
      clients_subtitle: "Click a client to expand their payouts and commission invoices.",
      col_lines: "Rows",
      col_ecom_to_pay: "Remaining to pay (e-com + services)",
      back_to_clients: "Back to clients",
      col_client: "Client",
      col_magazine: "Magazine",
      col_period: "Period",
      col_revenue: "Revenue",
      col_commission: "Commission",
      col_commission_due: "Commission due",
      col_net_due: "Net due",
      col_net_due_client: "Net to receive",
      col_paid: "Paid",
      col_paid_client: "Received",
      col_invoiced: "Invoiced",
      col_invoiced_client: "Owed",
      col_remaining: "Balance",
      col_status: "Status",
      col_actions: "",
      status_settled: "Settled",
      status_partial: "Partial",
      status_pending: "Pending",
      status_paid: "Paid",
      status_invoiced: "Invoiced",
      btn_mark_paid: "Record payout",
      btn_mark_invoiced: "Record invoice",
      btn_attach_invoice: "Attach invoice",
      attachments: "Attached invoices",
      download: "Download",
      mark_paid: "Mark as paid",
      unmark_paid: "Undo paid",
      col_ca_paid: "Revenue paid out",
      btn_ca: "Pay out revenue",
      ca_title: "Pay the e-commerce revenue to the publisher",
      ca_text: (client, period, due, left) => `${client} · ${period}: revenue incl. VAT ${due}, left to pay out ${left}.`,
      ca_amount: "Amount paid (€)",
      ca_reference: "Reference (transfer no., optional)",
      ca_ok: "Revenue payout recorded",
      ca_paid_on: (d) => `Revenue paid out on ${d}`,
      ca_done: "Paid out",
      ca_left: (amt) => `${amt} left`,
      ca_delete_confirm: "Delete this revenue payout?",
      status_unallocated: "To allocate",
      to_allocate: "To allocate (recorded without market)",
      allocate_title: "Attach to a market",
      allocate_payout: (d, amt) => `Payout of ${d} · ${amt}`,
      allocate_invoice: (ref, amt) => `Invoice ${ref} · ${amt}`,
      allocate_choose: "Choose the market…",
      allocated_ok: "Attached to market",
      filter_due: "To settle",
      filter_paid: "Paid",
      filter_all: "All",
      help_title: "How does it work?",
      help_physical: "Store sales · Payouts to receive",
      help_p1_title: "KD Presse calculates your net",
      help_p1: "We collect your store sales and calculate, for each issue and each market, the amount due to you (\"Net to receive\" column).",
      help_p2_title: "You attach your invoice",
      help_p2: "Issue an invoice for the \"Net to receive\" amount, then upload it as a PDF with the \"Attach invoice\" button on the matching line.",
      help_p3_title: "We pay you",
      help_p3: "As soon as the transfer is made, the line switches to \"Settled\" and the amount shows in the \"Received\" column.",
      help_ecom: "Online sales · Commissions to pay",
      help_e1_title: "Download the commission invoice",
      help_e1: "Each period, KD Presse pays you the revenue of your online sales and uploads its commission invoice under the line. Click \"Download\".",
      help_e2_title: "Pay the balance",
      help_e2: "Pay the amount shown in the \"Balance\" column. Once payment is received, the period switches to \"Paid\".",
      todo_title: "To do:",
      todo_attach: (n) => `${n} invoice${n > 1 ? "s" : ""} to attach`,
      todo_pay: (n, amt) => `${n} commission${n > 1 ? "s" : ""} to pay (${amt})`,
      invoice_received: "Invoice received",
      col_vat: "VAT",
      kpi_split: (ecom, svc) => `of which e-commerce ${ecom} · services ${svc}`,
      col_copies: "Copies sold",
      todo_services: (n, amt) => `${n} service invoice${n > 1 ? "s" : ""} to pay (${amt})`,
      col_market: "Market",
      attach_hint: "Issue your invoice for the net amount shown above, then upload the PDF. The amount is pre-filled, you can change it.",
      tip_market: "Your sales are split by market: Direct to retail (stores served directly), Wholesale France (distribution in France) and Worldwide Wholesale (distribution abroad). One invoice per line.",
      tip_net_due: "Store sales revenue incl. VAT, minus the KD Presse commission. This is the amount of your invoice.",
      tip_remaining: "What is left to pay on the line. Shown in red until it reaches zero.",
      tip_status: "Pending: nothing paid yet. Partial: part of it is paid. Settled / Paid: fully paid.",
      tip_remaining_ecom: "Commission (and any storage fee) you still have to pay KD Presse for this period.",
      faq_title: "Frequently asked questions",
      faq_q1: "Why is my balance in red?",
      faq_a1: "A red balance means an amount is still due on the line: a payout KD Presse still has to make to you, or a commission you still have to pay. It turns back to black once the line is settled.",
      faq_q2: "I attached the wrong invoice, what should I do?",
      faq_a2: "Under the line, in \"Attached invoices\", delete the file, then click \"Attach invoice\" again to upload the right PDF.",
      faq_q3: "Why does the same issue appear on several lines?",
      faq_a3: "An issue can be sold on several markets (Direct to retail, Wholesale France, Worldwide Wholesale). Each market has its own line: attach one invoice for each.",
      faq_q4: "How do I know I have been paid?",
      faq_a4: "The \"Received\" column shows the amount paid and the line switches to \"Settled\". Transfer details (date, amount, reference) appear under the line. Use the \"Paid\" filter to see settled lines only.",
      btn_settle: "Mark as paid",
      settle_title: "Mark the period as paid without invoice",
      settle_text: (client, period, amt) => `${client} · ${period}: the amount left to pay (${amt}) will be recorded as settled, without a PDF invoice. Invoices already recorded for this period are marked paid too.`,
      settle_date: "Settlement date",
      settled_ok: "Period marked as paid",
      settled_no_invoice: "Settled without invoice",
      marked_paid: "Invoice marked as paid.",
      marked_unpaid: "Paid status removed.",
      paid_on: "Paid on",
      invoice_attached: "Invoice attached.",
      error_pdf_required: "Please select a PDF file.",
      error_pdf_only: "Only PDF files are accepted.",
      no_payouts: "No eligible physical sales.",
      no_invoices: "No eligible e-commerce entries.",
      history: "History",
      ref: "Ref.",
      remove: "Delete",
      confirm_delete: "Delete this entry?",
      deleted: "Entry removed.",
      payout_saved: "Payout saved.",
      invoice_saved: "Invoice saved.",
      error_amount: "Invalid amount.",
      error_date: "Invalid date.",
      dlg_payout_title: "Record a payout",
      dlg_invoice_title: "Record an invoice",
      dlg_invoice_edit_title: "Edit invoice",
      help_pdf_keep: (n) => `Leave empty to keep the current PDF (${n}).`,
      invoice_updated: "Invoice updated",
      dlg_attach_invoice_title: "Attach an invoice",
      field_amount: "Amount (€)",
      field_amount_optional: "Amount (€) — optional",
      field_paid_at: "Payout date",
      field_invoiced_at: "Invoice date",
      field_reference: "Reference (wire, check…)",
      field_invoice_no: "Invoice number",
      field_notes: "Notes",
      field_pdf_invoice: "Invoice PDF file",
      help_pdf_required: "File must be in PDF format (max 10 MB).",
      placeholder_reference: "e.g. WIRE-2026-001",
      placeholder_invoice_no: "e.g. F2026-042",
    },
    reports: {
      eyebrow: "Reporting",
      title: "Detailed reports",
      filter_client: "Client",
      filter_magazine: "Magazine",
      filter_store: "Store",
      run: "Generate report",
      computing: "Computing…",
      excel: "Excel",
      pdf: "PDF",
      all_clients: "All clients",
      all_magazines: "All",
      n_magazines: (n) => `${n} issues selected`,
      all_stores: "All",
      kpi_qty: "Qty",
      kpi_rev: "Revenue (incl. VAT)",
      kpi_rev_ht: "Revenue (excl. VAT)",
      kpi_vat: "VAT",
      kpi_commission: "Commission",
      kpi_client_rev: "Client revenue",
      kpi_phys: "Physical Rev.",
      kpi_ecom: "E-com Rev.",
      table_by_mag: "By magazine",
      table_by_store: "By store",
      th_magazine: "Magazine",
      th_issue: "Issue",
      th_qty: "Qty",
      th_revenue: "Revenue",
      th_commission: "Commission",
      th_store: "Store",
      th_city: "City",
      th_country: "Country",
      no_data: "No data",
      excel_downloaded: "Excel export downloaded",
      pdf_downloaded: "PDF export downloaded",
    },
    clients: {
      eyebrow: "Management",
      title: "Clients",
      sub: "Magazine publishers distributed by your platform. Link an account so they can access their reporting.",
      new: "New client",
      edit_title: "Edit client",
      new_title: "New client",
      f_name: "Name",
      f_contact: "Contact email",
      f_country: "Country",
      f_rate_phys: "Physical commission (%)",
      f_rate_ecom: "E-com commission (%)",
      f_vat: "VAT (%)",
      rate_ecom_hint: "Leave the e-com rate empty to use the same as physical.",
      sel_country: "Select a country",
      country_hint: "Choose \"France\" to apply VAT on physical sales. Any other country: the unit price is converted to net (÷ 1.2) and no VAT is collected.",
      th_name: "Name",
      th_contact: "Contact",
      th_country: "Country",
      th_rate_phys: "Phys. rate",
      th_rate_ecom: "E-com rate",
      th_vat: "VAT",
      th_actions: "Actions",
      same_as_phys: (x) => `same (${x}%)`,
      none_yet: "No client yet. Create one to get started.",
      created: "Client created",
      updated: "Client updated — commissions recalculated on existing sales",
      deleted: "Deleted",
      confirm_del: "Delete this client?",
      accounts_title: (n) => `Linked accounts — ${n}`,
      accounts_existing: "Existing accounts",
      accounts_none: "No account linked. Create one below.",
      accounts_new: "Create a new account",
      access_hint: (n) => `This account will have read-only access to ${n}'s reporting.`,
      create_account: "Create account",
      new_password: "New password (min. 6 chars):",
      pw_reset: "Password reset",
      account_deleted: "Account deleted",
      account_created: (e) => `Account created for ${e}`,
      btn_accounts: "Accounts",
      btn_password: "Password",
    },
    magazines: {
      eyebrow: "Catalog",
      title: "Magazines",
      new: "New issue",
      edit_title: "Edit issue",
      new_title: "New issue",
      f_client: "Client",
      f_title: "Title",
      f_issue: "Issue / edition",
      f_price: "Unit price",
      f_currency: "Currency",
      f_cover: "Cover (image)",
      f_cover_hint: "JPG, PNG or WEBP · 5 MB max. The image is stored on the server.",
      cover_current: "Current cover",
      cover_uploaded: "Cover updated",
      sel_client: "Select",
      created: "Magazine created",
      updated: "Magazine updated",
      none_yet: "No magazine yet.",
      search: "Search a title or issue…",
      no_results: "No magazine matches your search.",
      no_client: "No client",
      issues_count: (n) => `${n} issue${n > 1 ? "s" : ""}`,
      titles_count: (n) => `${n} title${n > 1 ? "s" : ""}`,
      last_issue: "Latest:",
      f_rate: "Physical sales commission (%)",
      f_rate_ph: (r) => `Client rate: ${r} %`,
      f_rate_hint: "Leave empty to use the client rate. A rate set here applies to sales recorded after the change.",
    },
    stores: {
      eyebrow: "Network",
      title: "Retail stores",
      sub: "Stores worldwide distributing your magazines.",
      new: "New store",
      edit_title: "Edit store",
      new_title: "New store",
      f_name: "Name",
      f_city: "City",
      f_country: "Country",
      f_address: "Address",
      created: "Store created",
      updated: "Store updated",
      none_yet: "No store yet.",
    },
    sales: {
      eyebrow: "Physical distribution",
      title: "Physical sales",
      sub: "Record sales reported by each market.",
      new: "Add a sale",
      edit_title: "Edit sale",
      new_title: "New sale",
      f_magazine: "Magazine",
      f_store: "Store",
      f_qty: "Quantity",
      f_price: "Unit price (optional)",
      f_price_auto: "auto",
      f_price_hint: "Public price incl. VAT. For a client outside France the unit price is automatically converted to net (÷ 1.2).",
      f_rate: "Commission rate (%)",
      f_rate_ph: (r) => `Client rate: ${r} %`,
      f_rate_hint: "Leave empty to use the client rate. Set a rate for a store with a special deal (e.g. 50 %).",
      rate_specific: "specific rate",
      f_date: "Date",
      f_period: "Period",
      th_date: "Date",
      th_magazine: "Magazine",
      th_store: "Store",
      th_qty: "Qty",
      th_pu: "U.P.",
      th_revenue: "Revenue",
      th_commission: "Commission",
      created: "Sale recorded",
      updated: "Sale updated",
      none_yet: "No sale recorded for this issue.",
      no_magazines: "No magazine yet. Create a magazine first, then record sales.",
      no_issues: "No issue for this magazine.",
      bc_all_magazines: "All magazines",
      back_to_titles: "Back to magazines",
      back_to_issues: "Back to issues",
      col_issues: "Issues",
      col_issue: "Issue",
      col_sales: "Sales",
      kpi_titles: "Magazines",
      kpi_issues: "Issues",
      kpi_sales: "Sales",
      kpi_qty: "Quantity",
      kpi_revenue: "Revenue",
      btn_add_sale: "Add sale",
      card_net: "Client net",
      card_by_country: "Breakdown by country",
      card_other_countries: "other countries",
      card_see_sales: "View sales",
      units_short: "cp.",
    },
    ecom: {
      eyebrow: "E-commerce",
      title: "Online sales",
      sub: "Enter e-commerce revenue per period and client. You can also add storage fees re-invoiced to the client.",
      sub_client: "Your online sales month by month, with the commission and storage fees invoiced by KD Presse.",
      new: "New entry",
      edit_title: "Edit e-commerce entry",
      new_title: "New e-commerce entry",
      f_client: "Client",
      f_period_start: "Period start",
      f_period_end: "Period end",
      f_revenue: "Revenue (incl. VAT)",
      f_currency: "Currency",
      f_qty: "Quantity (optional)",
      f_storage_ht: "Storage fees (excl. VAT)",
      f_storage_hint: "20 % VAT (0 % if the client has no VAT). Total added to the commission to invoice.",
      f_notes: "Notes (optional)",
      f_notes_ph: "e.g. summer promo…",
      err_client: "Please select a client.",
      err_period: "Please select period start and end dates.",
      err_period_order: "End date must be after start date.",
      err_revenue: "Invalid amount.",
      save: "Save entry",
      kpi_entries: "Entries",
      kpi_revenue: "E-commerce Rev.",
      kpi_commission: "Cumulative commission (excl. VAT)",
      kpi_storage: "Cumulative storage (incl. VAT)",
      kpi_to_invoice: "To re-invoice (incl. VAT)",
      history: "Entries history",
      one_per: "One row per period × client",
      history_client: "Monthly detail",
      one_per_client: "Your online sales, month by month",
      th_your_rev: "Your net revenue",
      all_clients: "All clients",
      th_period: "Period",
      th_month: "Month",
      th_client: "Client",
      th_qty: "Quantity",
      th_revenue: "Revenue",
      th_commission: "Commission (excl. VAT)",
      th_storage: "Storage (incl. VAT)",
      th_invoiced: "To re-invoice (incl. VAT)",
      th_client_rev: "Client revenue",
      th_notes: "Notes",
      created: "Entry saved",
      updated: "Entry updated",
      deleted: "Deleted",
      none_yet: "No e-commerce entry yet. Click \"New entry\" to record a period.",
      detail: "Order detail (Excel)",
      detail_downloaded: "Order detail downloaded",
      f_rate: "E-commerce commission (%)",
      f_rate_ph: (r) => `Client rate: ${r} %`,
      f_rate_hint: "Leave empty to use the client rate. Set a rate to apply a different commission for this period.",
    },
    shopify: {
      title: "Shopify store",
      f_collections: "Shopify collections",
      linked: (n) => `Shopify · ${n} collection${n > 1 ? "s" : ""}`,
      search_ph: "Search a collection…",
      loading: "Loading collections…",
      no_match: "No matching collection.",
      n_products: (n) => `${n} product${n > 1 ? "s" : ""}`,
      unlink: "Unlink collection",
      picker_hint: "All online sales of these collections' products are attributed to this client. A collection can belong to one client only.",
      test: "Test connection",
      test_ok: (name, n) => `Connected to ${name} · ${n} orders`,
      sync_now: "Sync now",
      sync_started: "Sync started",
      sync_done: "Shopify sync finished",
      running: (n) => `Sync in progress… ${n} orders read`,
      last_sync: (d, n) => `Last sync: ${d} · ${n} orders · updated automatically every night`,
      never: "Never synced — click \"Sync now\" to import the full history.",
      unattributed: (amt) => `Unattributed sales: ${amt} (products outside linked collections)`,
      skipped: (n) => `${n} month(s) skipped: already covered by a manual entry`,
      replaceable: (n) => `${n} manual entr${n > 1 ? "ies" : "y"} replaceable by Shopify`,
      manual: "Entered",
      n_invoices: (n) => `${n} invoice(s) attached`,
      replace_btn: "Replace with Shopify",
      replace_title: "Replace the manual entry with Shopify",
      replace_text: (client, period, manual, shop, n) => `${client} · ${period}: the manual entry (${manual}) will be deleted and replaced by ${n} Shopify month(s) (${shop} in total).`,
      replace_storage: (amt) => `Storage fees (${amt} excl. VAT) will move to the last month of the period.`,
      replace_invoices: (n, amt) => `Warning: ${n} commission invoice(s) (${amt}) attached to this period will be permanently deleted, PDF included.`,
      replaced_ok: "Entry replaced by Shopify months",
      replace_payouts: (n) => `Warning: ${n} revenue payout(s) recorded on this period will be deleted.`,
      locked_hint: "Entry synced from Shopify: revenue, quantity and period update automatically. Only storage fees and the note can be edited.",
    },
    services: {
      title: "Other invoices · Services",
      subtitle: "Distribution, delivery, marketing… invoices sent to publishers, with payment tracking.",
      subtitle_client: "KD Presse service invoices (distribution, delivery, marketing…) to pay.",
      btn_add: "Add an invoice",
      dlg_title: "New service invoice",
      col_date: "Date",
      col_category: "Category",
      col_description: "Description",
      col_amount: "Amount incl. VAT",
      field_pdf: "Invoice (PDF)",
      placeholder_description: "e.g. Japan distribution – May 2026",
      cat_distribution: "Distribution",
      cat_delivery: "Delivery",
      cat_marketing: "Marketing",
      cat_other: "Other",
      error_required: "Client, date, amount and PDF are required.",
      created: "Invoice added",
      updated: "Invoice updated",
      dlg_edit_title: "Edit service invoice",
      btn_mark_paid: "Mark as paid",
      btn_unmark: "Undo payment",
      marked_paid: "Invoice marked as paid",
      confirm_delete: "Delete this invoice?",
      deleted: "Invoice deleted",
      empty: "No service invoice.",
    },
    accounts: {
      locked_until: (h) => `Locked until ${h}`,
      btn_unlock: "Unlock",
      unlocked: (e) => `Account unlocked: ${e}`,
      eyebrow: "Administration",
      title: "User accounts",
      sub: "All accounts with access to the platform — admins and clients.",
      new: "New account",
      edit_title: "Edit account",
      new_title: "New account",
      stat_total: "Total",
      stat_admins: "Admins",
      stat_clients: "Clients",
      stat_unlinked: "Unlinked",
      f_email: "Email",
      f_email_locked: "Email cannot be changed.",
      f_name: "Name",
      f_pw: "Password",
      f_pw_keep: "Password (leave empty to keep)",
      f_pw_ph: "min 6 chars",
      f_role: "Role",
      f_client: "Linked client",
      f_client_ph: "Choose",
      role_client: "Client",
      role_admin: "Administrator",
      filter_role: "All roles",
      filter_admins: "Admins",
      filter_clients: "Clients",
      filter_all_clients: "All clients",
      filter_unlinked: "Unlinked",
      th_account: "Account",
      th_email: "Email",
      th_role: "Role",
      th_client: "Linked client",
      th_created: "Created",
      you: "(you)",
      unlinked: "Unlinked",
      none_match: "No account matches the filters.",
      created: "Account created",
      updated: "Account updated",
      deleted: "Account deleted",
      cant_delete_self: "You cannot delete your own account",
      create_btn: "Create account",
      save_btn: "Save",
      pw_required: "Password (min. 6 chars) is required",
      pw_too_short: "Password too short",
      client_required: "Select a client for this account",
      pw_prompt: (e) => `New password for ${e} (min. 6 chars):`,
      pw_reset: "Password reset",
      btn_reset_pw: "Password",
      confirm_del: (e) => `Permanently delete account ${e}?`,
    },
  },
};

// Months
export const MONTHS = {
  fr: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
  en: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
};
